export const REMOVE_FROM_COMMITTEE_START =
  'REMOVE_FROM_COMMITTEE_START';
export const REMOVE_FROM_COMMITTEE_SUCCESS =
  'REMOVE_FROM_COMMITTEE_SUCCESS';
export const REMOVE_FROM_COMMITTEE_ERROR =
  'REMOVE_FROM_COMMITTEE_ERROR';
